import { render, staticRenderFns } from "./NotificationDetailModal.vue?vue&type=template&id=076610ee&"
import script from "./NotificationDetailModal.vue?vue&type=script&lang=js&"
export * from "./NotificationDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports